export default __webpack_public_path__ + "static/media/Project1_TechnicalSummary.56d10c07.pdf";